import { CREDIT_NOTE_HISTORY_URL, CREDIT_NOTE_URL, PURCHASE_URL } from "../../CONSTANTS";
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from "axios";
import Cookies from "universal-cookie";

const cook = new Cookies().get("loginData1");

const headersdata = {
  "content-type": "application/json",
  Accept: "application/json",
  Authorization: cook != undefined ? cook.accessToken : "",
};

const callPostAxios = (URL, data, errorIn) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(URL, data, {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(`Error in ${errorIn} axios!`);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

const callGetAxios = (URL, errorIn) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(URL, {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(`Error in ${errorIn} axios!`);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

const callPutAxios = (URL, data, errorIn) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .put(URL, data, {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(`Error in ${errorIn} axios!`);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCreditNote2 = (invoiceId) => {
  return callGetAxios(CREDIT_NOTE_URL() + "invoice/" + invoiceId, 'getCreditNote2');
};

export const addCreditNote = (data) => {
  return callPostAxios(CREDIT_NOTE_URL(), data, 'addCreditNote');
};

export const editCreditNote = (id, data) => {
  return callPutAxios(CREDIT_NOTE_URL() + id, data, 'getCreditNoteDetail');
};

export const getCreditNoteDetail = (id) => {
  return callGetAxios(CREDIT_NOTE_URL() + id, 'getCreditNoteDetail');
};

export const getCreditNoteByCustomer = (id) => {
  return callGetAxios(CREDIT_NOTE_URL() + "customer/" + id, 'getCreditNoteByCustomer');
};

export const getCreditNoteList = (data) => {
  return callPostAxios(CREDIT_NOTE_URL() + "getAllRecords", data, 'getAllRecords');
};

export const generateCreditNoteEInvoice = (data) => {
  return callPostAxios(CREDIT_NOTE_URL() + "generateCreditNoteEInvoice", data, 'generateCreditNoteEInvoice');
};

export const getApprovedCreditNotes = (data) => {
  return callPostAxios(CREDIT_NOTE_URL() + "approvedCreditNote", data, 'getApprovedCreditNotes');
};

export const getCreditNotesHistory = (creditNoteNo) => {
  const url = CREDIT_NOTE_HISTORY_URL() + `getCreditNoteHistory/${creditNoteNo}`;
  return callGetAxios(url, 'getCreditNotesHistory');
};


